// CB-326
class QlickerWidget {
    constructor() {
        this.element = document.querySelector(".main-application");
        let _that = this;
        this.init();
    }
    renderHREFS() {
        let ahrefs = document.querySelectorAll('.topic-usecase-rev-2 a');

        for (var i = 0; i < ahrefs.length; i++) {
            let item = ahrefs[i];
            if (/deeplink/.test(item.href)) {
                if (item.dataset.softwarepath) {
                    let route = window.eHelpFramework.getRoute("applications");
                    item.href = window.eHelpFramework.config.root + `${route}/${item.dataset.softwarepath}/${item.dataset.ospath}/${item.dataset.topicpath}`;
                } else {
                    item.href = window.eHelpFramework.config.root + `${item.dataset.manufacturerpath}/${item.dataset.devicepath}/${item.dataset.categorypath}/${item.dataset.topicpath}`;
                }
            }
        }
    }
    scaleAllContent() {
        let segments = document.querySelectorAll(".usecase-step");
        segments.forEach(elem => {
            let wrapper = elem.querySelector(".step-image-wrapper");
            // wrapper.style.width = this.max_width + "px";
            wrapper.style.height = this.max_height + "px";
            let device = elem.querySelector(".device-image img");
            let stepImage = elem.querySelector(".step-image.segment");
            let img = elem.querySelector(".step-image-holder img");
            let paddingTop = Number(window.getComputedStyle(wrapper).paddingTop.replace(/[^0-9\.]/g, ""));
            let paddingBottom = Number(window.getComputedStyle(wrapper).paddingBottom.replace(/[^0-9\.]/g, ""));
            let paddingLeft = Number(window.getComputedStyle(wrapper).paddingLeft.replace(/[^0-9\.]/g, ""));
            let paddingRight = Number(window.getComputedStyle(wrapper).paddingRight.replace(/[^0-9\.]/g, ""));

            let base_img = device || img;
            // console.log(base_img);
            let scale = 1;
            let left = 0;
            let top = 0;

            if (base_img.naturalHeight > base_img.naturalWidth) {
                //portrait
                if (base_img.naturalHeight >= (wrapper.offsetHeight - paddingBottom - paddingTop)) {
                    scale = (wrapper.offsetHeight - paddingBottom - paddingTop) / base_img.offsetHeight;
                    stepImage.style.transform = `scale(${scale})`;
                }
            } else {
                //landscape
                if (base_img.naturalWidth >= (wrapper.offsetWidth - paddingLeft - paddingRight)) {
                    scale = (wrapper.offsetWidth - paddingLeft - paddingRight) / base_img.offsetWidth;
                    stepImage.style.transform = `scale(${scale})`;
                }
            }
            this.qlicker(elem, scale);
            left = base_img.offsetWidth / 2 * scale;
            top = base_img.offsetHeight / 2 * scale;
            stepImage.style.left = (wrapper.offsetWidth / 2) - left + "px";
            stepImage.style.top = (wrapper.offsetHeight / 2) - top + "px";
        });
    }
    qlicker(step, scale) {
        scale = 1/scale;
        let stepImage = step.querySelector(".step-image.segment");
        let img = step.querySelector(".step-image-holder img");
        let top, left;

        left = (Number(img.dataset.screenpositionx) + Number(img.dataset.coordinatesleft) - 25);
        top = (Number(img.dataset.screenpositiony) + Number(img.dataset.coordinatestop) - 25);

        let qlicker = step.querySelector(".qlicker");



        if (qlicker) {
            qlicker.style.transform = `scale(${scale})`;
            qlicker.style.top = top + "px";
            qlicker.style.left = left + "px";
            if (stepImage.style.transform) {
                step.classList.add("zoomable");
            }
        }
        let _that = this;
        step.addEventListener("click", e => {
            _that.toogleZoom(e);
        })
    }
    toogleZoom(e) {
        // console.log(e);
        let img = e.currentTarget.querySelector(".step-image");
        let qlicker = e.currentTarget.querySelector(".qlicker");
        let wrapper = e.currentTarget.querySelector(".img-content");

        if (!qlicker) return;
        if (!img.style.transform) return;

        if (!img.classList.contains("zoomed")) {
            img.dataset.transform = img.style.transform;
            qlicker.dataset.transform = qlicker.style.transform;
            img.dataset.top = img.style.top;
            img.dataset.left = img.style.left;


            img.style.transform = "scale(1)";
            qlicker.style.transform = "scale(1)";

            let left = qlicker.style.left.replace(/[^0-9]/g, "");
            let top = qlicker.style.top.replace(/[^0-9]/g, "");

            let offY = wrapper.offsetHeight / 2;
            let offX = wrapper.offsetWidth / 2;

            img.style.left = (0 - left + offX) + "px";
            img.style.top = (0 - top + offY) + "px";

            img.classList.add("zoomed");
        } else {

            img.style.transform = img.dataset.transform;
            qlicker.style.transform = qlicker.dataset.transform;
            img.style.top = img.dataset.top;
            img.style.left = img.dataset.left;

            delete img.dataset.transform;
            delete qlicker.dataset.transform;
            delete img.dataset.top;
            delete img.dataset.left;
            img.classList.remove("zoomed");
        }




    }
    renderFixedSizes() {
        this.max_height = window.innerHeight * .59;
        let element;
        try {
            element = document.querySelector(".mdn-Container.topic-usecase-rev-2.container");
            if (!element) {
                element = this.element;
            }
        } catch (error) {
            console.log(error);
        }

        try {
            if (window.innerWidth < 640) {
                this.max_width = element.offsetWidth;
            } else {
                this.max_width = element.offsetWidth / 2;
                if (this.max_height > 416) this.max_height = 416;
            }
        } catch (error) {
            console.log(error);
        }
    }
    waitImagesToLoad() {
        let steps = this.element.querySelectorAll(`li.usecase-step`);
        let done = true;
        for (var i = 0; i < steps.length; i++) {
            let step = steps[i];
            let img = step.querySelector(".step-image-holder img");
            if (!img.naturalHeight || !img.naturalWidth) {
                done = false;
            } else {
                // console.log(img);
            }
        }
        if (done) {
            clearInterval(this._timer);
            this.renderFixedSizes();
            this.scaleAllContent();
            this.renderHREFS();
        }
    }
    init() {
        let _that = this;
        this._timer = setInterval(() => {
            _that.waitImagesToLoad();
        }, 200);
    }
}


window.addEventListener("eHelpFrameworkReady", e => {
    eHelpFramework.widgets.push(new QlickerWidget())
});